import { connect } from 'react-redux';
import { get } from 'lodash';

import SearchResults from './SearchResults';
import './SearchResults.css';

const mapStateToProps = (state, ownProps) => ({
  query: get(state, ['router', 'location', 'state', 'query'], null),
  searchQuery: get(state, ['router', 'location', 'search'], null),
  allowedPages: get(state, ['user', 'allowedPages'], [])
});

export default connect(mapStateToProps)(SearchResults);
